import type { SignDocument } from "../Models/Domain";
import type { SignDocumentApi } from "../Models/Api";

import useSignDocuments from "../Store";
import useUserStore from "@/Modules/User/Store";
import useClientsStore from "@/Modules/Patients/Store";

import { getAllSignDocuments } from "@/Services/TherapyApi/SignDocuments";
import { getSignDocuments } from "@/Services/TherapyApi/Clients";

import { isApiError } from "@/Services/Api/Typeguards/isApiError";

import SignDocumentTransformer from "@/Modules/Transformers/SignDocument";

import { hasValue } from "@/Utils/Objects";

async function fetchSignDocumentsActionHandler(): Promise<SignDocument[]> {
  const signDocumentsStore = useSignDocuments();
  const userStore = useUserStore();
  const clientsStore = useClientsStore();

  signDocumentsStore.isLoading = true;

  let documents: SignDocumentApi[] = [];

  if (userStore.getUserIsTherapist && hasValue(clientsStore.selected)) {
    documents = await getSignDocuments(clientsStore.selected.uuid).catch(() => []);
  } else if (userStore.getUserIsPatient) {
    documents = await getAllSignDocuments().catch(() => []);
  }

  if (isApiError(documents)) {
    documents = [];
  }

  signDocumentsStore.documents = documents.map(SignDocumentTransformer.toDomain);
  signDocumentsStore.isLoading = false;

  return signDocumentsStore.documents;
}

export default fetchSignDocumentsActionHandler;
